import { MarketEnum } from "../../../Enums/MarketEnum";
import ValueBoolean from "../../Value/ValueBoolean";
import FixturesModel from "../FixturesModel";

export default class OverCornersFixtureModel implements FixturesModel {
    public matchId: string = null;
    public market: MarketEnum = null;
    public matchType: string = "FOOTBALL";
    public prediction: ValueBoolean = null;

    constructor(matchId: string, market: MarketEnum, value: boolean) {
        this.matchId = matchId;
        this.market = market;
        this.prediction = new ValueBoolean();
        this.prediction.value = value;
    }
}